// Misc
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'

// Styles
const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  small: {
    height: theme.spacing.unit
  },
  default: {
    height: theme.spacing.unit * 2.5
  },
  large: {
    height: theme.spacing.unit * 4
  },
})

const Spacer = ({ mobileDivider, dividerProps, classes, small, large, ...rest }) => (
  <div
    {...rest}
    className={classNames(classes.root, {
      [classes.default]: !small && !large,
      [classes.small]: small,
      [classes.large]: large,
    })}
  >
    { !!mobileDivider && (
      <Hidden smUp>
        <Divider {...dividerProps} />
      </Hidden>
    ) }
  </div>
)

Spacer.propTypes = {
  classes: PropTypes.object.isRequired,
  mobileDivider: PropTypes.bool,
  dividerProps: PropTypes.any,
  small: PropTypes.bool,
  large: PropTypes.bool,
}

export default withStyles(styles)(Spacer)
